<template>
  <!-- <div>
    <div class="row">
      <div class="col">
        <SubMenu/>
      </div>
      <div class="col-3-center">
      </div>
    </div>
    <div class="row">
  <div class="col"></div>-->
  <div class="col-3-center">
    <!-- <h1>Info-Materialien</h1> -->
    <p>Für die Erarbeitung des räumlichen Leitbildes der Großen Kreisstadt Dachau stehen bereits eine Reihe von Gutachten und Analysen zur Verfügung. Diese sollen im laufenden Prozess unter räumlichen, funktionalen und städtebaulichen Gesichtspunkten gebündelt und in ihren jeweiligen Wechselwirkungen betrachtet werden. Im Ergebnis ergibt sich ein Gesamtbild für die zukünftige räumliche Entwicklung der Großen Kreisstadt Dachau, die dann auch in die Flächennutzungsplanung einfließen soll.</p>
    <p>Nachfolgend werden Schritt für Schritt die wesentlichen vorliegenden Gutachten und Analysen in Form von PDF allen interessierten Bürgerinnen und Bürgern zur Verfügung gestellt:</p>
    <hr />
    <div v-for="(file, i) in files" :key="i">
      <h2>{{ file.title }}</h2>
      <a :href="path + file.name" target="_blank" :download="file.name">{{ file.name }}</a>
      <hr />
    </div>
  </div>
  <!-- </div>
  </div>-->
</template>

<script>
export default {
  metaInfo: {
    title: "Info-Materialien"
  },
  data() {
    return {
      path: "/static/dokumente/",
      files: [
        {
          title: "Bevölkerungsentwicklung",
          name: "Steckbrief_01_Bevoelkerungsentwicklung.pdf"
        },
        {
          title: "Einzelhandelsentwicklung",
          name: "Steckbrief_02_Einzelhandelsentwicklung.pdf"
        },
        {
          title: "Energieversorgung",
          name: "Steckbrief_03_Energie.pdf"
        },
        {
          title: "Gewässerentwicklung",
          name: "Steckbrief_04_Gewaesserentwicklung.pdf"
        },
        {
          title: "Gewerbeflächen",
          name: "Steckbrief_05_Gewerbeflaechen.pdf"
        },
        {
          title: "Sport & Freizeit",
          name: "Steckbrief_06_Sport_und_Freizeit.pdf"
        },
        {
          title: "Verkehrsentwicklungsplan",
          name: "Steckbrief_07_Verkehr.pdf"
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.card {
  display: flex;
  // justify-content: center;
  align-items: center;
  a {
    margin-bottom: 10px !important;
  }
}
h2 {
  color: black !important;
}
</style>
